import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  handleCartItemQuantity,
  removeProductToCart,
} from "../redux/cartItems/actions";
import {
  addProductsToStock,
  handleStockItemQuantity,
} from "../redux/productsItems/actions";

const CartItem = ({ item }) => {
  const products = useSelector((state) => state.productItems);
  const { id, image, name, category, quantity, price } = item || {};
  const dispatch = useDispatch();
  let productItem = products.find((product) => product.id === id) || {};

  // Minus Quantity Handler
  const minusQuantityHandler = () => {
    if (quantity <= 1) return;
    dispatch(handleCartItemQuantity(id, "minus"));
    dispatch(handleStockItemQuantity(id, "plus"));
  };

  // plus Quantity Handler
  const plusQuantityHandler = () => {
    if (productItem?.quantity <= 0) return;
    dispatch(handleCartItemQuantity(id, "plus"));
    dispatch(handleStockItemQuantity(id, "minus"));
  };

  // Calculate total price for the product ...
  const totalPrice = () => {
    let total = price * quantity;
    return total;
  };

  // delete the product
  const deleteItemHandler = (id) => {
    if (!id) return;
    dispatch(addProductsToStock(id, quantity));
    dispatch(removeProductToCart(id));
  };

  return (
    <div className="cartCard">
      <div className="flex items-center col-span-6 space-x-6">
        {/* cart image  */}
        <img className="lws-cartImage" src={image} alt="product" />
        {/* cart item info  */}
        <div className="space-y-2">
          <h4 className="lws-cartName">{name}</h4>
          <p className="lws-cartCategory">{category}</p>
          <p>
            BDT <span className="lws-cartPrice">{totalPrice()}</span>
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
        {/* amount buttons  */}
        <div className="flex items-center space-x-4">
          <button
            className="lws-incrementQuantity"
            onClick={plusQuantityHandler}
            disabled={productItem.quantity <= 0}
          >
            <i className="text-lg fa-solid fa-plus"></i>
          </button>
          <span className="lws-cartQuantity">{quantity}</span>
          <button
            className="lws-decrementQuantity"
            onClick={minusQuantityHandler}
            disabled={quantity <= 1}
          >
            <i className="text-lg fa-solid fa-minus"></i>
          </button>
        </div>
        {/* price  */}
        <p className="text-lg font-bold">
          BDT <span className="lws-calculatedPrice">{totalPrice()}</span>
        </p>
      </div>
      {/* delete button  */}
      <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
        <button
          className="lws-removeFromCart"
          onClick={() => deleteItemHandler(id)}
        >
          <i className="text-lg text-red-400 fa-solid fa-trash"></i>
        </button>
      </div>
    </div>
  );
};

export default CartItem;
